import { FC } from "react";
import { useMutation } from "@apollo/client";
import { useRouter } from "next/router";
import { useUser } from "src/hooks/useUser";

import { forkSubjectMutation } from "src/lib/graphql/schemas.queries";
import {
  ForkSubjectMutation,
  ForkSubjectMutationVariables,
} from "src/lib/graphql/types";
import ForkIcon from "src/components/icons/ForkIcon";
import LoadingIndicator from "src/components/general/LoadingIndicator";
import SimpleDropdown from "src/components/SimpleDropdown";
import { OwnerOptionsEntity } from "./SchemaHeader";

type ForkSubjectProps = {
  name: string;
  namespace: string;
  version?: string;
  ownerOptions: OwnerOptionsEntity;
};

const ForkSubject: FC<ForkSubjectProps> = ({
  name,
  namespace,
  version,
  ownerOptions,
}) => {
  const router = useRouter();
  const [user] = useUser();

  const [forkSubject, { error, loading }] = useMutation<
    ForkSubjectMutation,
    ForkSubjectMutationVariables
  >(forkSubjectMutation, {
    onCompleted: ({ forkSubject }) =>
      router.push(`/@${forkSubject.namespace}/schemas/${forkSubject.name}`),
  });

  if (!user) {
    return null;
  }

  if (namespace === user.shortname && !user.memberOf?.length) {
    // the user has no orgs to fork into
    return null;
  }

  const filteredOptions = ownerOptions.filter(
    (option) => namespace !== option.value
  );

  return (
    <div className="fork-subject-form">
      {loading ? (
        <span style={{ minHeight: 40 }}>
          <LoadingIndicator loading />
        </span>
      ) : (
        <SimpleDropdown
          label={
            <span style={{ display: "flex", alignItems: "center" }}>
              Fork Subject <ForkIcon style={{ marginLeft: 5 }} />
            </span>
          }
          options={filteredOptions.map((option) => ({
            label: <span>{option.label}</span>,
            value: option.value,
            onSelect: (targetNamespace) => {
              forkSubject({
                variables: { name, namespace, version, targetNamespace },
              });
            },
          }))}
          className="schema-simple-dropdown"
          style="white"
        />
      )}
      <div style={{ minHeight: 14 }} className="error-text">
        {error?.message}
      </div>
    </div>
  );
};

export default ForkSubject;
